export const getShortCycle = (cycle: string) => {
  return cycle?.slice(-2);
};
